import { render, staticRenderFns } from "./education.vue?vue&type=template&id=33c15f46&scoped=true"
import script from "./education.vue?vue&type=script&lang=js"
export * from "./education.vue?vue&type=script&lang=js"
import style0 from "./education.vue?vue&type=style&index=0&id=33c15f46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c15f46",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EducationMenu: require('/builds/gb-developers/geekbrains-client/components/pages/education/EducationMenu/EducationMenu.vue').default,AppSection: require('/builds/gb-developers/geekbrains-client/components/global/AppSection.vue').default})
